import React, { useState } from "react";
import {
  FaAndroid,
  FaCogs,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import typeImage from "../../../assets/Docs/selectType.png";
import { TagComponent } from "../Tabs";


const Setup = () => {
  const [activeTab, setActiveTab] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    { id: "mobile", label: "Mobile App", icon: <FaMobileAlt /> },
  ];

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200">
      {/* Header */}
      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaCogs className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Setup</h1>
      </div>

      {/* Tags */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="blue" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      {/* Description */}
      <p className="text-gray-600 text-base leading-relaxed mb-8 text-left">
        After signing up, the first screen you see is the{" "}
        <strong>'Let's Get Started'</strong> screen. To start accepting orders,
        you need to become a <strong>Seller</strong> & to start placing orders,
        you need to become a <strong>Buyer</strong>. Choose an option &
        continue.
      </p>

      {/* Tab Navigation */}
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 mb-6 border-b border-[#b9ece6]">
        {tabs.map((tab) => {
          const isDisabled = tab.id === "mobile";
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => !isDisabled && setActiveTab(tab.id)}
              disabled={isDisabled}
              className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md text-sm transition-all w-full sm:w-auto
              ${
                isActive
                  ? "bg-[#1a9588] text-white shadow"
                  : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
              }
              ${
                isDisabled
                  ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]"
                  : ""
              }
            `}
            >
              {tab.icon}
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Image */}
      <div className="rounded-lg overflow-hidden p-2 sm:p-4 mb-8 bg-gray-50 border border-gray-200">
        <img
          src={typeImage}
          alt={`${activeTab} view`}
          className="rounded-md max-w-full h-auto max-h-[60vh] object-contain mx-auto"
        />
      </div>

      {/* Related Topics */}
      <div className="text-start">
        <h3 className="text-gray-800 font-semibold text-lg mb-3">
          Related Topics
        </h3>
        <div className="text-sm text-gray-600 space-y-2">
          <div>
            <a
              href="/documentation/seller-setup"
              className="hover:underline hover:text-[#1a9588]"
            >
              Seller Setup (For Accepting Orders)
            </a>
          </div>
          <div>
            <a
              href="/documentation/buyer-setup"
              className="hover:underline hover:text-[#1a9588]"
            >
              Buyer Setup (For Placing Orders)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setup;
